import { render } from "./Vegetarian.vue?vue&type=template&id=094757aa"
import script from "./Vegetarian.vue?vue&type=script&lang=js"
export * from "./Vegetarian.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__